<template>
  <b-col md="12" sm="12">
    <b-card no-body class="mx-4">
      <b-card-body class="p-4">
        <b-col md="12" sm="12">
          <b-row>
            <b-col md="12" sm="12">
              <img src="/static/img/logo.png" style="width: 20%;  "/>
            </b-col>
          </b-row>
        </b-col>
        <b-row>
          <b-col md="12" sm="12">
            <h1>Ficha de inscrição</h1>
          </b-col>
        </b-row>
        <b-form v-on:submit.prevent="onSubmit">
          <p class="text-muted">
            Caro/Cara participante da XI Conferência Nacional dos Direitos das Crianças e dos Adolescentes – CNDCA, sejam todos muito bem-vindos!
          </p>
          <p class="text-muted">
            Este é o nosso primeiro contato com você no âmbito da XI CNDCA, que nesta edição acontecerá totalmente online. É por aqui que vamos conhecer você. Por meio deste contato buscaremos entender as suas necessidades e as suas experiências, enquanto mobilizador/a social, o que irá nos ajudar a construir a primeira Conferência online do Brasil. E para que ela atenda as suas expectativas de futuro na promoção e defesa dos direitos das crianças e dos adolescentes, precisamos que preencha os dados solicitados nesta Ficha do Participante.
          </p>
          <p class="text-muted">
            Aqui você também vai poder confirmar qual eixo de discussão do seu interesse, para que assim possa interagir com mais efetividade. A partir do dia 15 de novembro de 2020 o ambiente virtual da XI CNDCA estará disponível para credenciamento. Você receberá um e-mail com as orientações, por isso é importante preencher todos os campos e com muita atenção. É a partir de sua participação e assiduidade que emitiremos seu certificado. E lembre-se, esse link é intransferível, por isso solicitamos que não compartilhe com ninguém alheio a conferência. E em caso de dúvidas, por favor, nos contate pelo e-mail: se.conanda@mdh.gov.br e ou pelo fone (61) 2027-3344.
          </p>

          <b-card>
            <h2>Dados básicos de cadastro</h2>
            <hr>
            <b-row>
              <b-col cols="12">
                <b-form-group label="Nome:">
                  <b-input-group class="mb-3">
                    <b-input-group-prepend>
                      <b-input-group-text><i class="icon-user"></i></b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input type="text"
                                  class="form-control"
                                  placeholder="Nome completo"
                                  autocomplete="nome"
                                  v-model.trim="$v.form.nome.$model"
                                  :state="chkState('nome')"/>
                    <b-form-invalid-feedback id="input1LiveFeedback3">Nome é obrigatório.</b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <b-form-group label="Nome social:">
                  <b-input-group class="mb-3">
                    <b-input-group-prepend>
                      <b-input-group-text><i class="icon-user"></i></b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input type="text"
                                  class="form-control"
                                  placeholder="Informe seu nome social caso possua, ou repita seu nome (esse nome será visualizado no ambiente virtual)"
                                  autocomplete="nome"
                                  v-model.trim="$v.form.nome_social.$model"
                                  :state="chkState('nome_social')"/>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <b-form-group label="E-mail:">
                  <b-input-group class="mb-3">
                    <b-input-group-prepend>
                      <b-input-group-text>@</b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input type="text"
                                  class="form-control"
                                  placeholder="E-mail"
                                  autocomplete="email"
                                  v-model.trim="$v.form.email.$model"
                                  :state="chkState('email')"/>
                    <b-form-invalid-feedback id="input1LiveFeedback7">Este é um campo obrigatório, e deve ser um
                      endereço de e-mail válido.
                    </b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <b-form-group label="Confirme o e-mail:">
                  <b-input-group class="mb-3">
                    <b-input-group-prepend>
                      <b-input-group-text>@</b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input type="text"
                                  class="form-control"
                                  id="confirmar-email"
                                  placeholder="Confirme o e-mail"
                                  oncut="return false"
                                  onpaste="return false"
                                  autocomplete="confirme-email"
                                  v-model.trim="$v.form.confirmaEmail.$model"
                                  :state="chkState('confirmaEmail')"/>
                    <b-form-invalid-feedback id="input1LiveFeedback8">Este é um campo obrigatório, e deve ser correspondente ao campo e-mail.
                    </b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>

            <h2>Ficha do/a Participante da XI CNDCA</h2>
            <hr>
            <b-row>
              <!--<b-col cols="12">
                <b-form-group>
                  <b-form-group label="Precisamos saber como se dará sua participação na XI CNDCA. Se desejar , insira aqui a sua foto.">
                    XXXUPLOADXXXX
                  </b-form-group>
                </b-form-group>
              </b-col> -->
            </b-row>
            <b-row>
              <b-col cols="12">
                  <strong>Consentimento de comunicação: </strong>Autorizo o tratamento dos dados pessoais fornecidos para envio de e-mails e análises de segmentação e perfil de públicos.<br>
                  <strong>Autorização de uso de imagem: </strong>Autorizo o uso de meu nome, minha imagem, estando ciente de que a transmissão/live poderá ser disponibilizada em quaisquer outros meios, inclusive sendo disponibilizada para  acesso público.<br>
                  Caso não queira utilizar vídeo e/ou som durante os trabalhos da Conferência, suas perguntas, comentários e sugestões poderão ser realizados de modo escrito, por chat.<br><br>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <b-form-checkbox
                        v-model="$v.form.termos.$model"
                        :options="options"
                        name="checkbox-validation">Autorizo o tratamento dos dados pessoais fornecidos para envio de e-mails e análises de segmentação e perfil de públicos.
                </b-form-checkbox>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <b-form-checkbox
                        v-model="$v.form.receber_copia.$model"
                        :options="options"
                        name="checkbox-validation">Caso queira receber uma cópia dessa pesquisa no seu e-mail sinalize aqui.
                </b-form-checkbox>
              </b-col>
            </b-row>
            <br><br>
            <b-row>
              <b-col md="8" sm="12">
                <b-form-group label="1. Na Conferência, você é?:"  invalid-feedback='É obrigatório informar quem você é na conferência.'>
                      <b-form-select v-model.trim="$v.form.participacao.$model" :state="chkState('participacao')" placeholder="" class="mb-3" :options='form_options.options_participacao'>
                    </b-form-select>
                </b-form-group>
              </b-col>
              <b-col md="4" sm="12" v-if="form.participacao === 'D'">
                <b-form-group label="1.1 Então você é?:"  invalid-feedback='É obrigatório informar quem você é na conferência.'>
                      <b-form-select v-model.trim="$v.form.tipo_delegado.$model" :state="chkState('tipo_delegado')" placeholder="" class="mb-3" :options='form_options.options_tipo_delegado'>
                    </b-form-select>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col md="6" sm="12" v-if="form.participacao !== 'A'">
                <b-form-group label="2. Na representação de seu estado, você é chefe de delegação?"  invalid-feedback='É obrigatório informar se você é chefe de delegação.'>
                      <b-form-select v-model.trim="$v.form.chefe_delegacao.$model" :state="chkState('chefe_delegacao')" placeholder="" class="mb-3" :options='options_sim_nao'>
                    </b-form-select>
                </b-form-group>
              </b-col>
              <b-col md="6" sm="12" v-if="form.participacao !== 'A'">
                <b-form-group label="3. Qual é o perfil de sua representação?"  invalid-feedback='É obrigatório informar o seu perfil de representação.'>
                      <b-form-select v-model.trim="$v.form.perfil_representacao.$model" :state="chkState('perfil_representacao')" placeholder="" class="mb-3" :options='form_options.options_perfil_representacao'>
                    </b-form-select>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" v-if="form.participacao !== 'A'">
                <b-form-group label="4. Qual é a natureza de sua representação na XI CNDCA?"  invalid-feedback='É obrigatório informar a natureza de sua representação na XI CNDCA.'>
                      <b-form-select v-model.trim="$v.form.natureza_representacao.$model" :state="chkState('natureza_representacao')" placeholder="" class="mb-3" :options='form_options.options_natureza_representacao'>
                    </b-form-select>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row v-if="form.natureza_representacao === 'P' && form.participacao !== 'A'">
              <b-col cols="12">
                <b-form-group label="4.1 Que órgão você representa?">
                  <b-input-group class="mb-3">
                    <b-form-input type="text"
                                  class="form-control"
                                  placeholder="Nome do órgão"
                                  v-model.trim="$v.form.orgao_representacao.$model"
                                  :state="chkState('orgao_representacao')"/>
                    <b-form-invalid-feedback id="inputLiveFeedback1">É obrigatório informar o órgão que representa.</b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <b-form-group label="4.2 Qual segmento você representa?"  invalid-feedback='É obrigatório informar o segmento que representa.'>
                    <b-form-select v-model.trim="$v.form.segmento_representacao.$model" :state="chkState('segmento_representacao')" placeholder="" class="mb-3" :options='form_options.options_segmento_representacao'>
                    </b-form-select>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row v-if="form.natureza_representacao === 'S' && form.participacao !== 'A'">
              <b-col cols="12">
                <b-form-group label="4.3 A qual instituição/órgão você está vinculado?">
                  <b-input-group class="mb-3">
                    <b-form-input type="text"
                                  class="form-control"
                                  placeholder="Nome do órgão/instituição"
                                  v-model.trim="$v.form.orgao_instituicao_vinculado.$model"
                                  :state="chkState('orgao_instituicao_vinculado')"/>
                    <b-form-invalid-feedback id="inputLiveFeedback1">É obrigatório informar o órgão/instituição que está vinculado.</b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row v-if="form.natureza_representacao === 'S' && form.participacao !== 'A'">
              <b-col md="6" sm="12">
                <b-form-group label="4.4 Em qual estado está localizada a instituição/órgão a que você está vinculado/a?" :state="chkState('estado_orgao_instituicao')" invalid-feedback='É obrigatório informar o estado do órgão/instituicão.'>
                  <multiselect
                    v-model="$v.form.estado_orgao_instituicao.$model"
                    :options="estados"
                    label="sigla"
                    track-by="id"
                    placeholder="Selecione"
                    selectLabel="" deselectLabel="" selectedLabel=""
                    :tagglabe="true"
                    :multiple="true"
                    :max="1"
                    :state="chkState('estado_orgao_instituicao')">
                      <span slot="maxElements"></span>
                      <span slot="noResult">Nenhum encontrado</span>
                      <span slot="noOptions">Lista vazia</span>
                    </multiselect>
                </b-form-group>
              </b-col>

              <b-col md="6" sm="12">
                <b-form-group label="4.4.1 Em qual cidade está localizada a instituição/órgão a que você está vinculado/a?" :state="chkState('cidade_orgao_instituicao')" invalid-feedback='É obrigatório informar a cidade do órgão/instituicão.'>
                  <multiselect
                    v-model="$v.form.cidade_orgao_instituicao.$model"
                    :options="cidades_orgao_instituicao"
                    label="cidade"
                    track-by="id"
                    placeholder="Selecione"
                    return="id"
                    :multiple="true"
                    :max="1"
                    :state="chkState('cidade_orgao_instituicao')">
                    </multiselect>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row v-if="form.natureza_representacao === 'P' && form.participacao !== 'A'">
              <b-col cols="12">
                <b-form-group label="4.5 Qual o telefone da instituição/órgão a que você está vinculado?">
                  <b-input-group class="mb-3">
                    <b-form-input v-mask="'(###) #####.####'"
                                  type="text"
                                  class="form-control"
                                  placeholder="Informe o telefone da instituição/órgão"
                                  v-model.trim="$v.form.telefone_orgao_instituicao.$model"
                                  :state="chkState('telefone_orgao_instituicao')"/>
                    <b-form-invalid-feedback id="inputLiveFeedback2">É obrigatório informar o telefone do órgão/instituição que está vinculado.</b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row v-if="form.participacao !== 'A'">
              <b-col cols="12">
                <b-form-group label="5. Em qual Eixo Temático você atuará na Conferência?"  invalid-feedback='É obrigatório informar o eixo temático.'>
                      <b-form-select v-model.trim="$v.form.eixo_tematico.$model" :state="chkState('eixo_tematico')" placeholder="" class="mb-3" :options='form_options.options_eixo_tematico'>
                    </b-form-select>
                </b-form-group>
              </b-col>
            </b-row>

            <h2>Dados Pessoais</h2>
            <hr>
            <p class="text-muted">
              Bom, já sabemos seu nome e de que forma participará da Conferência, mas precisamos que complete a ficha com os seus dados pessoais.
            </p>

            <b-row>
              <b-col cols="12">
                <b-form-group label="6. Qual sua nacionalidade?"  invalid-feedback='Nacionalidade é obrigatório.'>
                  <b-form-select v-model.trim="$v.form.nacionalidade.$model" :state="chkState('nacionalidade')" placeholder="" class="mb-3" :options='form_options.options_nacionalidade'>
                  </b-form-select>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row v-show="form.nacionalidade == 'B' || form.nacionalidade == 'N'">
              <b-col cols="12">
                <b-form-group label="7. CPF:">
                  <b-input-group class="mb-3">
                    <b-form-input v-mask="'###.###.###-##'"
                                  type="text"
                                  class="form-control"
                                  placeholder="CPF"
                                  v-model="$v.form.cpf.$model"
                                  :state="chkState('cpf')"
                                  />
                    <b-form-invalid-feedback id="inputLiveFeedback3">CPF é obrigatório.</b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row v-show="form.nacionalidade == 'E'">
              <b-col cols="12">
                <b-form-group label="7. Passaporte:">
                  <b-input-group class="mb-3">
                    <b-form-input type="text"
                                  class="form-control"
                                  placeholder="Passaporte"
                                  v-model="$v.form.passaporte.$model"
                                  :state="chkState('passaporte')"
                                  />
                    <b-form-invalid-feedback id="inputLiveFeedback4">Passaporte é obrigatório.</b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row v-show="form.nacionalidade == 'B' || form.nacionalidade == 'N'">
              <b-col cols="12">
                <b-form-group label="8. Número do Registro Geral (RG):">
                  <b-input-group class="mb-3">
                    <b-form-input v-mask='"##########"'
                                  type="text"
                                  class="form-control"
                                  placeholder="Número do Registro Geral (RG)"
                                  v-model="$v.form.rg.$model"
                                  :state="chkState('rg')"
                                  />
                    <b-form-invalid-feedback id="inputLiveFeedback5">RG é obrigatório.</b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row v-if="form.nacionalidade">
              <b-col cols="12">
                <b-form-group label="9. Órgão Emissor">
                  <b-input-group class="mb-3">
                    <b-form-input type="text"
                                  class="form-control"
                                  placeholder="Órgão Emissor"
                                  v-model="$v.form.orgao_emissor.$model"
                                  :state="chkState('orgao_emissor')"
                                  />
                    <b-form-invalid-feedback id="inputLiveFeedback6">Órgão Emissor é obrigatório.</b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="12">
                <b-form-group label="10. Data de Nascimento">
                  <b-input-group class="mb-3">
                    <b-form-input v-mask="'##/##/####'"
                                  type="text"
                                  class="form-control"
                                  placeholder="Data de Nascimento"
                                  v-model="$v.form.data_nascimento.$model"
                                  :state="chkState('data_nascimento')"
                                  />
                    <b-form-invalid-feedback id="inputLiveFeedback7">Data de nascimento é obrigatório.</b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row v-show="form.nacionalidade == 'B' || form.nacionalidade == 'N'">
              <b-col md="6" sm="12">
                <b-form-group label="11. Estado em que nasceu" :state="chkState('estado_origem')" invalid-feedback='É obrigatório informar o estado em que nasceu.'>
                  <multiselect
                    v-model="$v.form.estado_origem.$model"
                    :options="estados"
                    label="sigla"
                    track-by="id"
                    placeholder="Selecione"
                    selectLabel="" deselectLabel="" selectedLabel=""
                    :tagglabe="true"
                    :multiple="true"
                    :max="1"
                    :state="chkState('estado_origem')">
                      <span slot="maxElements"></span>
                      <span slot="noResult">Nenhum encontrado</span>
                      <span slot="noOptions">Lista vazia</span>
                    </multiselect>
                </b-form-group>
              </b-col>

              <b-col md="6" sm="12">
                <b-form-group label="12. Cidade onde nasceu" :state="chkState('cidade_origem')" invalid-feedback='É obrigatório informar a cidade em que nasceu.'>
                  <multiselect
                    v-model="$v.form.cidade_origem.$model"
                    :options="cidades_origem"
                    label="cidade"
                    track-by="id"
                    placeholder="Selecione"
                    return="id"
                    :multiple="true"
                    :max="1"
                    :state="chkState('cidade_origem')">
                    </multiselect>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col md="6" sm="12">
                <b-form-group label="13. Estado em que mora atualmente" :state="chkState('estado_moradia')" invalid-feedback='É obrigatório informar o estado em que mora atualmente.'>
                  <multiselect
                    v-model="$v.form.estado_moradia.$model"
                    :options="estados"
                    label="sigla"
                    track-by="id"
                    placeholder="Selecione"
                    selectLabel="" deselectLabel="" selectedLabel=""
                    :tagglabe="true"
                    :multiple="true"
                    :max="1"
                    :state="chkState('estado_moradia')">
                      <span slot="maxElements"></span>
                      <span slot="noResult">Nenhum encontrado</span>
                      <span slot="noOptions">Lista vazia</span>
                    </multiselect>
                </b-form-group>
              </b-col>

              <b-col md="6" sm="12">
                <b-form-group label="14. Cidade onde mora atualmente" :state="chkState('cidade_moradia')" invalid-feedback='É obrigatório informar a cidade em que mora atualmente.'>
                  <multiselect
                    v-model="$v.form.cidade_moradia.$model"
                    :options="cidades_moradia"
                    label="cidade"
                    track-by="id"
                    placeholder="Selecione"
                    return="id"
                    :multiple="true"
                    :max="1"
                    :state="chkState('cidade_moradia')">
                    </multiselect>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="12">
                <b-form-group label="15. Telefone celular (WhatsApp e SMS)">
                  <b-row>
                    <b-col cols="4">
                      <b-input-group class="mb-3">
                        <b-form-input v-mask="'###'"
                                      type="text"
                                      class="form-control"
                                      placeholder="DDD"
                                      v-model="$v.form.telefone_celular_ddd.$model"
                                      :state="chkState('telefone_celular_ddd')"
                                      />
                        <b-form-invalid-feedback id="inputLiveFeedback8">O DDD é obrigatório.</b-form-invalid-feedback>
                      </b-input-group>
                    </b-col>
                    <b-col cols="8">
                      <b-input-group class="mb-3">
                        <b-form-input v-mask="'#####-####'"
                                      type="text"
                                      class="form-control"
                                      placeholder="Número"
                                      v-model="$v.form.telefone_celular_numero.$model"
                                      :state="chkState('telefone_celular_numero')"
                                      />
                        <b-form-invalid-feedback id="inputLiveFeedback9">O número do telefone celular é obrigatório.</b-form-invalid-feedback>
                      </b-input-group>
                    </b-col>
                  </b-row>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="12">
                <b-form-group label="16. Qual gênero você se identifica?"  invalid-feedback='O gênero é obrigatório.'>
                  <b-form-select v-model.trim="$v.form.genero.$model" :state="chkState('genero')" placeholder="" class="mb-3" :options='form_options.options_genero'>
                  </b-form-select>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="12">
                <b-form-group label="17. Quanto sua orientação sexual?"  invalid-feedback='A orientação sexual é obrigatória.'>
                  <b-form-select v-model.trim="$v.form.orientacao_sexual.$model" :state="chkState('orientacao_sexual')" placeholder="" class="mb-3" :options='form_options.options_orientacao_sexual'>
                  </b-form-select>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="12">
                <b-form-group label="18. Você gostaria de informar sua identidade gênero?">
                  <b-form-select v-model.trim="$v.form.identidade_genero.$model" :state="chkState('identidade_genero')" placeholder="" class="mb-3" :options='form_options.options_identidade_genero'>
                  </b-form-select>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="12">
                <b-form-group label="19. Raça/Etnia"  invalid-feedback='A raça/etnia é obrigatório.'>
                  <b-form-select v-model.trim="$v.form.raca_etnia.$model" :state="chkState('raca_etnia')" placeholder="" class="mb-3" :options='form_options.options_raca_etnia'>
                  </b-form-select>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="12">
                <b-form-group label="20. Se você é representante de Povos e comunidades tradicionais indique qual">
                  <b-form-select v-model.trim="$v.form.povo_comunidade.$model" :state="chkState('povo_comunidade')" placeholder="" class="mb-3" :options='form_options.options_povo_comunidade'>
                  </b-form-select>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row v-if="form.povo_comunidade === 'OU'">
              <b-col cols="12">
                <b-form-group label="20.1. Qual outro?">
                  <b-input-group class="mb-3">
                    <b-form-input type="text"
                                  class="form-control"
                                  placeholder="Infore o outro povo ou comunidade tradicional"
                                  v-model="$v.form.povo_comunidade_outro.$model"
                                  :state="chkState('povo_comunidade_outro')"
                                  />
                    <b-form-invalid-feedback id="inputLiveFeedback11">O povo e comunidade é obrigatório.</b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="12">
                <b-form-group label="21. Você é representante de pessoas do campo, pertencentes às famílias assentadas pela reforma agrária e/ou famílias de agricultores?">
                  <b-form-select v-model.trim="$v.form.representa_campo.$model" :state="chkState('representa_campo')" placeholder="" class="mb-3" :options='options_sim_nao'>
                  </b-form-select>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="12">
                <b-form-group label="22. Você é representante de famílias acampadas em áreas rurais ou urbanas?">
                  <b-form-select v-model.trim="$v.form.representa_acampamento.$model" :state="chkState('representa_acampamento')" placeholder="" class="mb-3" :options='options_sim_nao'>
                  </b-form-select>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="12">
                <b-form-group label="23. Você é representante de migrantes, refugiados e apátridas?">
                  <b-form-select v-model.trim="$v.form.representa_imigrante.$model" :state="chkState('representa_imigrante')" placeholder="" class="mb-3" :options='options_sim_nao'>
                  </b-form-select>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="12">
                <b-form-group label="24. Indique se você se encontra em uma ou mais dessas situações" :state="chkState('situacoes_participante')" invalid-feedback='Informe se você se encontra em uma ou mais dessas situações.'>
                    <multiselect
                          v-model="$v.form.situacoes_participante.$model"
                          :options="form_options.options_situacao"
                          label="text"
                          track-by="value"
                          placeholder="Selecione"
                          selectLabel="" deselectLabel="" selectedLabel=""
                          :tagglabe="true"
                          :multiple="true"
                          :state="chkState('situacoes_participante')">
                      <span slot="maxElements"></span>
                      <span slot="noResult">Nenhum encontrado</span>
                      <span slot="noOptions">Lista vazia</span>
                    </multiselect>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="12">
                <b-form-group label="25. Faixa etária">
                  <b-form-select v-model.trim="$v.form.faixa_etaria.$model" :state="chkState('faixa_etaria')" placeholder="" class="mb-3" :options='form_options.options_faixa_etaria'>
                  </b-form-select>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="12">
                <b-form-group label="26. Grau de instrução">
                  <b-form-select v-model.trim="$v.form.grau_instrucao.$model" :state="chkState('grau_instrucao')" placeholder="" class="mb-3" :options='form_options.options_grau_instrucao'>
                  </b-form-select>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row v-if="form.grau_instrucao === 'OU'">
              <b-col cols="12">
                <b-form-group label="Qual outro?">
                  <b-input-group class="mb-3">
                    <b-form-input type="text"
                                  class="form-control"
                                  placeholder="Infore o outro grau de instrução"
                                  v-model="$v.form.grau_instrucao_outro.$model"
                                  :state="chkState('grau_instrucao_outro')"
                                  />
                    <b-form-invalid-feedback id="inputLiveFeedback12">O outro grau de instrução é obrigatório.</b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="12">
                <b-form-group label="27. Você possui alguma deficiência física ou intelectual?">
                  <b-form-select v-model.trim="$v.form.deficiencia.$model" :state="chkState('deficiencia')" placeholder="" class="mb-3" :options='options_sim_nao'>
                  </b-form-select>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row v-if="form.deficiencia === true">
              <b-col cols="12">
                <b-form-group label="27.1. Pode nos informar qual? Mas caso você tenha deficiências múltiplas, favor sinalizar mais de uma opção." :state="chkState('deficiencias')"  invalid-feedback='É obrigatório informar a deficiência.'>
                    <multiselect
                          v-model="$v.form.deficiencias.$model"
                          :options="form_options.options_deficiencias"
                          label="text"
                          track-by="value"
                          placeholder="Selecione"
                          selectLabel="" deselectLabel="" selectedLabel=""
                          :tagglabe="true"
                          :multiple="true"
                          :state="chkState('deficiencias')">
                      <span slot="maxElements"></span>
                      <span slot="noResult">Nenhum encontrado</span>
                      <span slot="noOptions">Lista vazia</span>
                    </multiselect>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row v-if="form.deficiencia === true">
              <b-col cols="12">
                <b-form-group label="27.2. Quanto a serviços e estruturas acessíveis na Conferência, você precisará? Marque somente o estritamente necessário.">
                    <multiselect
                          v-model="$v.form.servicos_acessiveis.$model"
                          :options="form_options.options_servicos_acessiveis"
                          label="text"
                          track-by="value"
                          placeholder="Selecione"
                          selectLabel="" deselectLabel="" selectedLabel=""
                          :tagglabe="true"
                          :multiple="true"
                          :state="chkState('servicos_acessiveis')">
                      <span slot="maxElements"></span>
                      <span slot="noResult">Nenhum encontrado</span>
                      <span slot="noOptions">Lista vazia</span>
                    </multiselect>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="12">
                <b-form-group label="28. Onde você usa a Internet?" :state="chkState('local_uso')" invalid-feedback='É obrigatório informar o local de uso' >
                  <multiselect
                          v-model="$v.form.local_uso.$model"
                          :options="form_options.options_local_acesso"
                          label="text"
                          track-by="value"
                          placeholder="Selecione"
                          selectLabel="" deselectLabel="" selectedLabel=""
                          :tagglabe="true"
                          :multiple="true"
                          :state="chkState('local_uso')">
                      <span slot="maxElements"></span>
                      <span slot="noResult">Nenhum encontrado</span>
                      <span slot="noOptions">Lista vazia</span>
                    </multiselect>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row v-if="exibirOutroLocal">
              <b-col cols="12">
                <b-form-group label="28.1. Possuí outro local de uso?">
                  <b-input-group class="mb-3">
                    <b-form-input type="text"
                                  class="form-control"
                                  placeholder="Infore o outro local de uso."
                                  v-model="$v.form.local_uso_outro.$model"
                                  :state="chkState('local_uso_outro')"
                                  />
                    <b-form-invalid-feedback id="inputLiveFeedback12">O outro local de uso é obrigatório.</b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="12">
                <b-form-group label="29. Para acesso a Internet você geralmente utiliza">
                  <b-form-select v-model.trim="$v.form.equipamento_uso.$model" :state="chkState('equipamento_uso')" placeholder="" class="mb-3" :options='form_options.options_equipamento_acesso'>
                  </b-form-select>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="12">
                <b-form-group label="30. E sua Internet é?">
                  <b-form-select v-model.trim="$v.form.tipo_internet.$model" :state="chkState('tipo_internet')" placeholder="" class="mb-3" :options='form_options.options_tipo_internet'>
                  </b-form-select>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="12">
                <b-form-group label="31. Você consegue ver vídeos, lives e interagir através de sua Internet de modo">
                  <b-form-select v-model.trim="$v.form.qualidade_internet.$model" :state="chkState('qualidade_internet')" placeholder="" class="mb-3" :options='form_options.options_qualidade_internet'>
                  </b-form-select>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row v-if="$v.form.faixa_etaria.$model === '01'">
              <b-col cols="12">
                <b-form-group label="32. Se você é criança ou adolescente participante do evento, por favor deixe aqui os dados de seu responsável">
                  <b-row>
                    <b-col cols="12">
                      <b-form-input type="text"
                                  class="form-control"
                                  placeholder="Nome do responsável"
                                  v-model="$v.form.nome_responsavel.$model"
                                  :state="chkState('nome_responsavel')"
                                  />
                    </b-col>
                    <br><br>
                    <b-col cols="12">
                      <b-form-input v-mask='"###.###.###-##"'
                              type="text"
                              class="form-control"
                              placeholder="CPF do responsável"
                              v-model="$v.form.cpf_responsavel.$model"
                              :state="chkState('cpf_responsavel')"
                              />
                    </b-col>
                    <br><br>
                    <b-col cols="12">
                        <b-form-input type="text"
                              class="form-control"
                              placeholder="E-mail do responsável"
                              v-model="$v.form.email_responsavel.$model"
                              :state="chkState('email_responsavel')"
                              />
                    </b-col>
                    <br><br>
                    <b-col cols="4">
                      <b-form-input v-mask='"###"'
                              type="text"
                              class="form-control"
                              placeholder="DDD do Telefone do responsável"
                              v-model="$v.form.telefone_responsavel_ddd.$model"
                              :state="chkState('telefone_responsavel_ddd')"
                              />
                    </b-col>
                    <b-col cols="8">
                      <b-form-input v-mask='"#####-####"'
                              type="text"
                              class="form-control"
                              placeholder="Número do telefone do responsável"
                              v-model="$v.form.telefone_responsavel_numero.$model"
                              :state="chkState('telefone_responsavel_numero')"
                              />
                    </b-col>
                  </b-row>
                </b-form-group>
              </b-col>
            </b-row>
          </b-card>
        </b-form>
      </b-card-body>
      <b-card-footer class="p-12">
        <b-row>
          <b-col v-if="!loading" md="3" offset-md="3">
            <b-button block variant="primary" :disabled="disable_buttons" v-on:click="onSubmit">
              <i class="fa fa-plus"></i>&nbsp;
              <span>Enviar</span>
            </b-button>
          </b-col>
          <b-col v-else md="3" offset-md="3">
            <b-button block variant="primary" :disabled="false" v-on:click="onSubmit">
              <b-spinner small type="grow"></b-spinner>Enviando...
            </b-button>
          </b-col>
          <b-col md="3">
            <b-button block variant="secondary" :disabled="disable_buttons" @click="navigate('/participante')">
              <i class="fa fa-mail-reply-all"></i>&nbsp;&nbsp;<span>Cancelar</span>
            </b-button>
          </b-col>
        </b-row>
      </b-card-footer>
    </b-card>
  </b-col>
</template>

<script>
import Vue from 'vue'
import AuthTemplate from '@/templates/auth/AuthTemplate'
import VueSelect from 'vue-select'
import Multiselect from 'vue-multiselect'
import {validationMixin} from 'vuelidate'
import {required, email, sameAs, requiredIf} from 'vuelidate/lib/validators'
import miniToastr from 'mini-toastr'

Vue.component('multiselect', Multiselect)

miniToastr.init()

export default {
  name: 'CadastroParticipante',
  components: {
    AuthTemplate,
    VueSelect,
    Multiselect
  },
  mixins: [validationMixin],
  validations: {
    form: {
      nome: {
        required
      },
      nome_social: {
        required
      },
      email: {
        required,
        email
      },
      confirmaEmail: {
        required,
        email,
        sameAsEmail: sameAs('email')
      },
      termos: {
        required
      },
      receber_copia: {},
      participacao: {
        required
      },
      tipo_delegado: {
        required: requiredIf(function () {
          return this.form.participacao === 'D'
        })
      },
      chefe_delegacao: {
        required: requiredIf(function () {
          return this.form.participacao !== 'A'
        })
      },
      perfil_representacao: {
        required: requiredIf(function () {
          return this.form.participacao !== 'A'
        })
      },
      natureza_representacao: {
        required: requiredIf(function () {
          return this.form.participacao !== 'A'
        })
      },
      orgao_representacao: {
        required: requiredIf(function () {
          return this.form.natureza_representacao === 'P'
        })
      },
      segmento_representacao: {
        required
      },
      orgao_instituicao_vinculado: {
        required: requiredIf(function () {
          return this.form.natureza_representacao === 'S'
        })
      },
      estado_orgao_instituicao: {
        required: requiredIf(function () {
          return this.form.natureza_representacao === 'S'
        })
      },
      cidade_orgao_instituicao: {
        required: requiredIf(function () {
          return this.form.natureza_representacao === 'S'
        })
      },
      telefone_orgao_instituicao: {
        required: requiredIf(function () {
          return this.form.natureza_representacao === 'P'
        })
      },
      eixo_tematico: {
        required: requiredIf(function () {
          return this.form.participacao !== 'A'
        })
      },
      nacionalidade: {
        required
      },
      cpf: {
      },
      passaporte: {
        required: requiredIf(function () {
          return this.form.nacionalidade === 'E'
        })
      },
      rg: {
        required: requiredIf(function () {
          return this.form.nacionalidade === 'B' || this.form.nacionalidade === 'N'
        })
      },
      orgao_emissor: { required },
      data_nascimento: { required },
      estado_origem: {
        required: requiredIf(function () {
          return this.form.nacionalidade === 'B' || this.form.nacionalidade === 'N'
        })
      },
      cidade_origem: {
        required: requiredIf(function () {
          return this.form.nacionalidade === 'B' || this.form.nacionalidade === 'N'
        })
      },
      estado_moradia: { required },
      cidade_moradia: { required },
      telefone_celular_ddd: { required },
      telefone_celular_numero: { required },
      email_contato: { },
      genero: { required },
      orientacao_sexual: { required },
      identidade_genero: { },
      raca_etnia: { required },
      povo_comunidade: { },
      povo_comunidade_outro: {
        required: requiredIf(function () {
          return this.form.povo_comunidade === 'OU'
        })
      },
      representa_campo: { required },
      representa_acampamento: { required },
      representa_imigrante: { required },
      situacoes_participante: { required },
      faixa_etaria: { required },
      grau_instrucao: { required },
      grau_instrucao_outro: {
        required: requiredIf(function () {
          return this.form.grau_instrucao === 'OU'
        })
      },
      deficiencia: { required },
      deficiencias: {
        required: requiredIf(function () {
          return this.form.deficiencia
        })
      },
      servicos_acessiveis: {},
      servico_acessivel_outro: {
        required: requiredIf(function () {
          return this.form.servicos_acessiveis === 'OU'
        })
      },
      local_uso: { required },
      local_uso_outro: {
        required: requiredIf(function () {
          return this.exibirOutroLocal
        })
      },
      equipamento_uso: { required },
      tipo_internet: { required },
      qualidade_internet: { required },
      nome_responsavel: { },
      cpf_responsavel: { },
      email_responsavel: { },
      telefone_responsavel_ddd: { },
      telefone_responsavel_numero: { }
    }
  },
  created () {
    this.loadForm()
  },
  data () {
    return {
      loading: false,
      exibeCpf: true,
      exibeDeficiencia: false,
      form: {
        nome: '',
        nome_social: '',
        email: '',
        confirmaEmail: '',
        termos: false,
        receber_copia: false,
        participacao: null,
        chefe_delegacao: null,
        perfil_representacao: null,
        natureza_representacao: null,
        orgao_representacao: null,
        segmento_representacao: null,
        orgao_instituicao_vinculado: null,
        estado_orgao_instituicao: null,
        cidade_orgao_instituicao: null,
        telefone_orgao_instituicao: null,
        nacionalidade: null,
        eixo_tematico: null,
        cpf: null,
        passaporte: null,
        rg: null,
        orgao_emissor: null,
        data_nascimento: null,
        estado_origem: null,
        cidade_origem: null,
        estado_moradia: null,
        cidade_moradia: null,
        telefone_celular_ddd: null,
        telefone_celular_numero: null,
        email_contato: null,
        genero: null,
        orientacao_sexual: null,
        identidade_genero: null,
        raca_etnia: null,
        povo_comunidade: null,
        povo_comunidade_outro: null,
        representa_campo: null,
        representa_acampamento: null,
        representa_imigrante: null,
        situacoes_participante: [],
        faixa_etaria: null,
        grau_instrucao: null,
        grau_instrucao_outro: null,
        deficiencia: null,
        deficiencias: null,
        servicos_acessiveis: null,
        servico_acessivel_outro: null,
        local_uso: null,
        local_uso_outro: null,
        equipamento_uso: null,
        tipo_internet: null,
        qualidade_internet: null,
        nome_responsavel: null,
        cpf_responsavel: null,
        email_responsavel: null,
        telefone_responsavel_ddd: null,
        telefone_responsavel_numero: null
      },
      form_options: {
        options_participacao: [],
        options_tipo_delegado: [],
        options_perfil_representacao: [],
        options_natureza_representacao: [],
        options_segmento_representacao: [],
        options_eixo_tematico: [],
        options_nacionalidade: [],
        options_genero: [],
        options_orientacao_sexual: [],
        options_identidade_genero: [],
        options_raca_etnia: [],
        options_povo_comunidade: [],
        options_situacao: [],
        options_faixa_etaria: [],
        options_grau_instrucao: [],
        options_deficiencias: [],
        options_servicos_acessiveis: [],
        options_local_acesso: [],
        options_equipamento_acesso: [],
        options_tipo_internet: [],
        options_qualidade_internet: []
      },
      options_sim_nao: [
        {'value': true, 'text': 'Sim'},
        {'value': false, 'text': 'Não'}
      ],
      estados: [],
      cidades_orgao_instituicao: [],
      cidades_origem: [],
      cidades_moradia: [],

      termo_aceite: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
      disabled_cidades: true,
      disable_buttons: false,
      valueAceiteCadastro: null,
      salvarForm: false,
      options: [
        {value: true}
      ]
    }
  },
  computed: {
    participacoes () {
      return [
        {'id': 1, 'nome': 'xxx'},
        {'id': 2, 'nome': 'xxx'}
      ]
    },
    exibirOutroLocal () {
      let local = this.$v.form.local_uso.$model
      let valid = false

      for (let i in local) {
        if (local[i].value === 'O') {
          valid = true
        }
      }

      return valid
    },
    isValid () {
      return !this.$v.form.$anyError
    }
  },
  watch: {
    '$v.form.estado_orgao_instituicao.$model': function () {
      if (this.$v.form.estado_orgao_instituicao.$model.length > 0) {
        Vue.http.get('api/cidade/buscarCidades/' + this.$v.form.estado_orgao_instituicao.$model[0].id).then(response => {
          this.cidades_orgao_instituicao = response.data.data.cidades
        })
      } else if (this.$v.form.estado_orgao_instituicao.$model.length === 0) {
        this.form.cidade_orgao_instituicao = null
      }
    },
    '$v.form.estado_origem.$model': function () {
      if (this.$v.form.estado_origem.$model.length > 0) {
        Vue.http.get('api/cidade/buscarCidades/' + this.$v.form.estado_origem.$model[0].id).then(response => {
          this.cidades_origem = response.data.data.cidades
        })
      } else if (this.$v.form.estado_origem.$model.length === 0) {
        this.form.cidade_origem = null
      }
    },
    '$v.form.estado_moradia.$model': function () {
      if (this.$v.form.estado_moradia.$model.length > 0) {
        Vue.http.get('api/cidade/buscarCidades/' + this.$v.form.estado_moradia.$model[0].id).then(response => {
          this.cidades_moradia = response.data.data.cidades
        })
      } else if (this.$v.form.estado_moradia.$model.length === 0) {
        this.form.cidade_moradia = null
      }
    },
    '$v.form.possui_deficiencia.$model': function () {
      let possuiDeficiencia = this.form.possui_deficiencia
      this.exibeDeficiencia = possuiDeficiencia === '1'
    }
  },
  methods: {
    loadForm () {
      // Carrega o template com as options das combos
      Vue.http.get('api/participante/atributo/template').then(response => {
        this.form_options = response.data.data
      }).catch(e => {
        console.log('Servidor está fora! ' + e)
      })

      // Carrega os estados
      Vue.http.get('api/estado/buscarEstadosPorRegiao').then(response => {
        this.estados = response.data.data.estados
        console.log(this.estados)
      })
    },
    salvar () {
      let form = this.$v.form
      let data = {
        nome: form.nome.$model,
        nome_social: form.nome_social.$model,
        email: form.email.$model,
        termos: form.termos.$model,
        receber_copia: form.receber_copia.$model,
        participacao: form.participacao.$model,
        tipo_delegado: form.tipo_delegado.$model,
        chefe_delegacao: form.chefe_delegacao.$model,
        perfil_representacao: form.perfil_representacao.$model,
        natureza_representacao: form.natureza_representacao.$model,
        orgao_representacao: form.orgao_representacao.$model,
        segmento_representacao: form.segmento_representacao.$model,
        orgao_instituicao_vinculado: form.orgao_instituicao_vinculado.$model,
        cidade_orgao_instituicao: form.cidade_orgao_instituicao.$model !== null ? form.cidade_orgao_instituicao.$model[0].id : null,
        telefone_orgao_instituicao: form.telefone_orgao_instituicao.$model,
        nacionalidade: form.nacionalidade.$model,
        eixo_tematico: form.eixo_tematico.$model,
        cpf: form.cpf.$model !== null ? form.cpf.$model.replace(/[^\d]+/g, '') : null,
        passaporte: form.passaporte.$model,
        rg: form.rg.$model,
        orgao_emissor: form.orgao_emissor.$model,
        data_nascimento: form.data_nascimento.$model,
        cidade_origem_id: form.cidade_origem.$model !== null ? form.cidade_origem.$model[0].id : null,
        cidade_moradia_id: form.cidade_moradia.$model !== null ? form.cidade_moradia.$model[0].id : null,
        telefone_celular_ddd: form.telefone_celular_ddd.$model,
        telefone_celular_numero: form.telefone_celular_numero.$model,
        email_contato: form.email_contato.$model,
        genero: form.genero.$model,
        orientacao_sexual: form.orientacao_sexual.$model,
        identidade_genero: form.identidade_genero.$model,
        raca_etnia: form.raca_etnia.$model,
        povo_comunidade: form.povo_comunidade.$model,
        povo_comunidade_outro: form.povo_comunidade_outro.$model,
        representa_campo: form.representa_campo.$model,
        representa_acampamento: form.representa_acampamento.$model,
        representa_imigrante: form.representa_imigrante.$model,
        situacoes_participante: [],
        faixa_etaria: form.faixa_etaria.$model,
        grau_instrucao: form.grau_instrucao.$model,
        grau_instrucao_outro: form.grau_instrucao_outro.$model,
        deficiencia: form.deficiencia.$model,
        deficiencias: [],
        servicos_acessiveis: [],
        servico_acessivel_outro: form.servico_acessivel_outro.$model,
        local_uso: [],
        local_uso_outro: form.local_uso_outro.$model,
        equipamento_uso: form.equipamento_uso.$model,
        tipo_internet: form.tipo_internet.$model,
        qualidade_internet: form.qualidade_internet.$model,
        nome_responsavel: form.nome_responsavel.$model,
        cpf_responsavel: form.cpf_responsavel.$model !== null ? form.cpf_responsavel.$model.replace(/[^\d]+/g, '') : null,
        email_responsavel: form.email_responsavel.$model,
        telefone_responsavel_ddd: form.telefone_responsavel_ddd.$model,
        telefone_responsavel_numero: form.telefone_responsavel_numero.$model
      }

      let servicosAcessiveis = form.servicos_acessiveis.$model
      for (let k in servicosAcessiveis) {
        data.servicos_acessiveis.push(servicosAcessiveis[k].value)
      }

      let situacoesParticipante = form.situacoes_participante.$model
      for (let k in situacoesParticipante) {
        data.situacoes_participante.push(situacoesParticipante[k].value)
      }

      let deficiencias = form.deficiencias.$model
      for (let k in deficiencias) {
        data.deficiencias.push(deficiencias[k].value)
      }

      let localUso = form.local_uso.$model
      for (let k in localUso) {
        data.local_uso.push(localUso[k].value)
      }

      this.loading = true
      Vue.http.post('api/participante', data).then(response => {
        if (response.body.success) {
          miniToastr.setIcon('success', 'i', {'class': 'fa fa-check'})
          miniToastr.success(response.body.msg, 'Sucesso!', 7000)
          this.$router.push({path: '/participante'})
        } else {
          miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
          miniToastr.error(response.body.msg, 'Alerta', 5000)
        }

        this.loading = false
      }).catch(e => {
        console.log('Servidor está fora! ' + e)
      })
    },
    confirmar () {
      this.$bvModal.msgBoxConfirm('Tem certeza que deseja continuar?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          this.salvar()
        }
      }).catch(erro => {
        console.log(erro)
      })
    },
    onSubmit () {
      this.salvarForm = true
      if (this.validate() && this.validateTermos()) {
        this.confirmar()
      }
    },
    chkState (val) {
      const field = this.$v.form[val]

      if (!field.$model && !this.salvarForm) {
        return null
      }

      return !field.$dirty || !field.$invalid
    },
    findFirstError (component = this) {
      if (component.state === false) {
        if (component.$refs.input) {
          component.$refs.input.focus()
          return true
        }
        if (component.$refs.check) {
          component.$refs.check.focus()
          return true
        }
      }
      let focused = false
      component.$children.some((child) => {
        focused = this.findFirstError(child)
        return focused
      })

      return focused
    },
    validate () {
      this.$v.$touch()
      this.$nextTick(() => this.findFirstError())
      return this.isValid
    },
    validateTermos () {
      let bool = true
      if (!this.form.termos) {
        bool = false
        miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
        miniToastr.error('Aceite os termos para incrição no evento.', this.titulo_toast, 5000)
      }

      return bool
    },
    navigate (route) {
      this.$router.push(route)
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
  h1 {
    text-align: center
  }

  .text-muted  {
    color: #000 !important;
  }

  legend {
    font-weight: bold !important
  }
</style>



// WEBPACK FOOTER //
// src/pages/site/interna/participante/ParticipanteCadastrar.vue